export enum ShotOffTargetAttribute {
  LeftFoot = 408,
  RightFoot = 409,
  DirectFreeKick = 410,
  Head = 436,
  InsidePenaltyArea = 437,
  OutsidePenaltyArea = 438,
  ShotWoodwork = 439,
  Crossbar = 739,
  Post = 740,
  Volley = 849,
  BicycleKick = 850,
  Chip = 851,
  OneOnOne = 852,
  BigChanceMissed = 889,
  Normal = 920,
  FirstTouch = 921,
  NoPressure = 922,
  LightPressure = 923,
  HighPressure = 924,
  ClearPosition = 925,
  OneDefender = 926,
  TwoOrMoreDefenders = 927,
  UncomfortablePosition = 928,
  EmptyNet = 929,
  OtherBodyPart = 930,
}
